<div id="standard-modal" role="dialog" aria-labelledby="standard-modalLabel">
  <div class="modal-content">

    <div class="modal-header">
      <h4 class="modal-title" id="standard-modalLabel">{{ 'shared.csatModuleEdit.title' | translate }}</h4>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true" (click)="close()"></button>
    </div>

    <div class="modal-body">
      <form [formGroup]="formGroup">

        <div class="mb-3">
          <label class="fw-medium">{{ 'shared.csatModuleEdit.evaluationQuestionLabel' | translate }}</label>
          <input type="text" class="form-control" formControlName="evaluationQuestionCSAT" [placeholder]="'shared.csatModuleEdit.evaluationQuestionPlaceholder' | translate" />
          <field-error-component [field]="'evaluationQuestionCSAT'" [label]="'shared.csatModuleEdit.evaluationQuestionLabel' | translate" [formGroup]="formGroup" />
        </div>
        <div class="mb-3">
          <label class="fw-medium mb-2"><b>{{ 'shared.csatModuleEdit.responseOptions' | translate }}</b></label><br />
          <label class="fw-medium">{{ 'shared.csatModuleEdit.note1Label' | translate }}</label>
          <input type="text" class="form-control" formControlName="note1CSAT" [placeholder]="'shared.csatModuleEdit.note1Placeholder' | translate" />
          <field-error-component [field]="'note1CSAT'" [label]="'shared.csatModuleEdit.note1Label' | translate" [formGroup]="formGroup" />
        </div>
        <div class="mb-3">
          <label class="fw-medium">{{ 'shared.csatModuleEdit.note2Label' | translate }}</label>
          <input type="text" class="form-control" formControlName="note2CSAT" [placeholder]="'shared.csatModuleEdit.note2Placeholder' | translate" />
          <field-error-component [field]="'note2CSAT'" [label]="'shared.csatModuleEdit.note2Label' | translate" [formGroup]="formGroup" />
        </div>
        <div class="mb-3">
          <label class="fw-medium">{{ 'shared.csatModuleEdit.note3Label' | translate }}</label>
          <input type="text" class="form-control" formControlName="note3CSAT" [placeholder]="'shared.csatModuleEdit.note3Placeholder' | translate" />
          <field-error-component [field]="'note3CSAT'" [label]="'shared.csatModuleEdit.note3Label' | translate" [formGroup]="formGroup" />
        </div>
        <div class="mb-3">
          <label class="fw-medium">{{ 'shared.csatModuleEdit.note4Label' | translate }}</label>
          <input type="text" class="form-control" formControlName="note4CSAT" [placeholder]="'shared.csatModuleEdit.note4Placeholder' | translate" />
          <field-error-component [field]="'note4CSAT'" [label]="'shared.csatModuleEdit.note4Label' | translate" [formGroup]="formGroup" />
        </div>
        <div class="mb-3">
          <label class="fw-medium">{{ 'shared.csatModuleEdit.note5Label' | translate }}</label>
          <input type="text" class="form-control" formControlName="note5CSAT" [placeholder]="'shared.csatModuleEdit.note5Placeholder' | translate" />
          <field-error-component [field]="'note5CSAT'" [label]="'shared.csatModuleEdit.note5Label' | translate" [formGroup]="formGroup" />
        </div>
        <div class="mb-3">
          <label class="fw-medium">{{ 'shared.csatModuleEdit.timeoutLabel' | translate }}</label>
          <input type="text" class="form-control" formControlName="noResponseTimeoutCSAT" [placeholder]="'shared.csatModuleEdit.timeoutPlaceholder' | translate" />
          <field-error-component [field]="'noResponseTimeoutCSAT'" [label]="'shared.csatModuleEdit.timeoutLabel' | translate" [formGroup]="formGroup" />
        </div>
        <div class="mb-3">
          <label class="fw-medium">{{ 'shared.csatModuleEdit.maxAttemptsLabel' | translate }}</label>
          <input type="text" class="form-control" formControlName="amountAttemptedResponseCSAT" [placeholder]="'shared.csatModuleEdit.attemptsPlaceholder' | translate" />
          <field-error-component [field]="'amountAttemptedResponseCSAT'" [label]="'shared.csatModuleEdit.maxAttemptsLabel' | translate" [formGroup]="formGroup" />
        </div>
        <div class="mb-3">
          <label class="fw-medium">{{ 'shared.csatModuleEdit.supervisorNotificationLabel' | translate }}</label>
          <input type="text" class="form-control" formControlName="ratingNotificationSupervisorCSAT" [placeholder]="'shared.csatModuleEdit.attemptsPlaceholder' | translate" />
          <field-error-component [field]="'ratingNotificationSupervisorCSAT'" [label]="'shared.csatModuleEdit.supervisorNotificationLabel' | translate" [formGroup]="formGroup" />
        </div>
        <div class="mb-3">
          <label class="fw-medium">{{ 'shared.csatModuleEdit.messageRating5Label' | translate }}</label>
          <textarea
            class="form-control"
            rows="8"
            [placeholder]="'shared.csatModuleEdit.messageRating5Placeholder' | translate"
            formControlName="messageSendCSAT"
            #textarea>
          </textarea>
          <field-error-component [field]="'messageSendCSAT'" [label]="'shared.csatModuleEdit.messageRating5Label' | translate" [formGroup]="formGroup" />

          <div class="d-flex align-items-center justify-content-end">
            <i
              class="btn btn-sm p-2 d-flex align-items-center justify-content-center"
              (click)="applyFormat('bold', textarea)"
              [title]="'shared.csatModuleEdit.boldTitle' | translate"
            >
            <i class="ri-bold"></i>
            </i>
            <i
              class="btn btn-sm p-2 d-flex align-items-center justify-content-center"
              (click)="applyFormat('italic', textarea)"
              [title]="'shared.csatModuleEdit.italicTitle' | translate"
            >
              <i class="ri-italic"></i>
            </i>
            <i
              class="btn btn-sm p-2 d-flex align-items-center justify-content-center"
              (click)="applyFormat('underline', textarea)"
              [title]="'shared.csatModuleEdit.underlineTitle' | translate"
            >
              <i class="ri-underline"></i>
            </i>
            <i
              class="btn btn-sm p-2 d-flex align-items-center justify-content-center"
              (click)="toogleContainerEmoji()"
              [title]="'shared.csatModuleEdit.emojisTitle' | translate"
            >
              <i class="ri-emotion-happy-line"></i>
            </i>

              <div class="dropdown">
                <button 
                  class="btn btn-sm p-2 d-flex align-items-center justify-content-center" 
                  type="button" 
                  data-bs-toggle="dropdown" 
                  aria-expanded="false"
                  [title]="'shared.csatModuleEdit.variablesTitle' | translate"
                >
                  <i class="ri-code-line"></i>
                </button>
                <ul class="dropdown-menu">
                  @for (variable of templateVariableList; track variable.value) {
                    <li>
                      <a class="dropdown-item" href="#" (click)="setVariableInContent(variable.value, $index); $event.preventDefault()">
                        <i class="ri-{{ variable.icon }} me-2"></i>
                        {{ variable.label }}
                      </a>
                    </li>
                  }
                </ul>
              </div>

            <div
              class="position-relative"
            >
              @if (showContainerEmoji) {
                <div class="position-absolute end-0 bottom-100 z-3">
                  <emoji-mart
                    (emojiSelect)="addEmoji($event)"
                    [i18n]="translator"
                    [darkMode]="false"
                  ></emoji-mart>
                </div>
              }
            </div>
          </div>
        </div>

      </form>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="close()">
        {{ 'shared.csatModuleEdit.cancel' | translate }}
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        [mat-dialog-close]="true"
        [disabled]="!formGroup.valid"
        (click)="save()"
      >
        {{ (isNew ? 'shared.csatModuleEdit.save' : 'shared.csatModuleEdit.update') | translate }}
        @if (loading) {
          <mat-spinner
            [diameter]="25"
            [color]="'accent'"
            mode="indeterminate"
          />
        }
      </button>
    </div>

  </div>
</div>
